/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { Routers } from "../../../../../../../constant/Routers"
import { Translate } from "../../../../../../../constant/Translate"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import {
  AllCountriesResType,
  CitiesResType,
} from "../../../../../../../infrastructure/handlers/countries/models"
import { GeneralMastersResType } from "../../../../../../../infrastructure/handlers/generalMasters/models"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { scheduleApi } from "../../../../apis"
import { Variables } from "../../../../constants/list/variables"
import {
  SchedulesListDataType,
  SchedulesListPostType,
  UseSchedulesListApiProps,
} from "../../../../models/list"
import { SchedulesSearchFormDataType } from "../../../../models/list/search"
import { useVariablesApi } from "../useVariablesApi"
import { convertSearchDataSubmit } from "./convertSearchDataSubmit"
import { getDataSearchBasic } from "./getDataSearchBasic"
import { getDataSubmit } from "./getDataSubmit"
import { convertDataSource } from "./convertDataSource"
import { DepartmentsResType } from "../../../../../../../infrastructure/handlers/departments/models"
import { departmentsApi } from "../../../../../../../infrastructure/handlers/departments"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { generalMastersApi } from "../../../../../../../infrastructure/handlers/generalMasters"
import { countriesApi } from "../../../../../../../infrastructure/handlers/countries"
import { replaceStringParam } from "../../../../../../../utils/replaceStringParam"

const { DPTD, UNIVERSAL_COUNTRY_CODE } = GeneralCode
const { SCR210, SCR210_USER_SEARCH, SCR973 } = Routers
const { MESSAGE_I0022 } = Translate
const { SCHEDULE_LIST_OVER_RECORD } = Variables

export const useApi = (props: UseSchedulesListApiProps) => {
  const { isGetCountries, isRoleSubAdmin } = props
  const {
    arrivalCities,
    countries,
    dataSource,
    dataSourceSelected,
    dataSubmit,
    dataTemp,
    departments,
    dispatchType,
    dispatchTypeAll,
    dispatchTypeDetail,
    form,
    fullName,
    handleSetDefaultSortedInfo,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenLoadData,
    isOpenShowData,
    isPathnameAttentionsOrSafeties,
    isPathnameSchedules,
    isResetTable,
    onCancelLoadData,
    onCancelShowData,
    onChange,
    onChangeTable,
    onOpenLoadData,
    onOpenShowData,
    overRecordLabel,
    pathname,
    perItem,
    purposeTravel,
    push,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setArrivalCities,
    setCountries,
    setDataSource,
    setDataSubmit,
    setDataTemp,
    setDepartments,
    setDispatchType,
    setDispatchTypeAll,
    setDispatchTypeDetail,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingLayout,
    setIsLoadingTable,
    setIsResetTable,
    setOverRecordLabel,
    setPurposeTravel,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    state,
    travelScheduleId,
    travelerId,
    userInformation,
  } = useVariablesApi(isRoleSubAdmin)

  const getSchedules = async (
    data: SchedulesListPostType,
    isSearchCondition?: boolean,
  ) => {
    const _data = getDataSubmit({
      data,
      isFromSCR114UserSearch: pathname === SCR210_USER_SEARCH,
      isFromSCR115: state?.isFromSCR115,
      pathname,
      searchCondition: state?.searchCondition,
      travelerId:
        data?.["travelerId" as keyof SchedulesListPostType] ?? travelerId,
      userInformation,
    })
    setDataSubmit(_data)

    handleSetDefaultSortedInfo()
    // APIを呼び出し、「渡航予定情報の一覧」のデータ一覧を取得する。
    await scheduleApi
      .getSchedules(_data)
      .then((res: SchedulesListDataType[]) => {
        if (res.length > SCHEDULE_LIST_OVER_RECORD) {
          const data = convertDataSource(res)
          if (isSearchCondition) {
            onOpenLoadData()
            setDataTemp(data)
          } else {
            setDataSource(data.slice(0, SCHEDULE_LIST_OVER_RECORD))
            setOverRecordLabel(
              replaceStringParam(MESSAGE_I0022, SCHEDULE_LIST_OVER_RECORD),
            )
          }
        } else {
          const data = convertDataSource(res)
          setOverRecordLabel("")
          setDataSource(data)
        }
        document.getElementById("title-right")?.focus()
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
      .finally(() => {
        setIsLoadingLayout(false)
        setIsLoadingTable(false)
      })
  }

  const onOkLoadData = () => {
    onCancelLoadData()
    const _data = getDataSubmit({
      data: dataSubmit,
      isFromSCR115: state?.isFromSCR115,
      isGetAllData: true,
      pathname,
      searchCondition: state?.searchCondition,
      travelerId:
        dataSubmit?.["travelerId" as keyof SchedulesListPostType] ?? travelerId,
      userInformation,
    })

    handleSetDefaultSortedInfo()
    setIsLoadingTable(true)
    // APIを呼び出し、「渡航予定情報の一覧」のデータ一覧を取得する。
    scheduleApi
      .getSchedules(_data)
      .then((res: SchedulesListDataType[]) => {
        setDataSource(res)
        setIsLoadingTable(false)
        setOverRecordLabel("")
        setTimeout(() => {
          document.getElementById("title-right")?.focus()
        }, 600)
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
  }

  const onCancelCustomLoadData = () => {
    onCancelLoadData()
    onOpenShowData()
  }

  const onOkShowData = () => {
    const _dataTemp = dataTemp.slice(0, SCHEDULE_LIST_OVER_RECORD)
    setDataSource(_dataTemp)
    setOverRecordLabel(
      replaceStringParam(MESSAGE_I0022, SCHEDULE_LIST_OVER_RECORD),
    )
    onCancelShowData()
    setTimeout(() => {
      document.getElementById("title-right")?.focus()
    }, 600)
  }

  const handleSearch = async (values: SchedulesSearchFormDataType) => {
    const dataSearch = getDataSearchBasic(values)
    const data = convertSearchDataSubmit({
      isPathnameAttentionsOrSafeties,
      isPathnameSchedules,
      pathname,
      searchCondition: dataSearch,
      userInformation,
      values,
    })

    setIsResetTable(true)
    setIsLoadingTable(true)
    onChange(1, 25)
    setTimeout(async () => {
      setSearchCondition({
        ...dataSearch,
        arrivalDateTime: "",
        departureDateTime: "",
      })

      setIsResetTable(false)
      await getSchedules(data, true)
    }, 500)
  }

  const onChangeDispatchType = (
    value: string,
    dispatchTypes?: GeneralMastersResType[],
  ) => {
    const _dispatchTypeAll = dispatchTypeAll.length
      ? dispatchTypeAll
      : dispatchTypes
    const _dispatchTypeDetail: OptionItemType[] =
      _dispatchTypeAll
        ?.filter((item) => item.key2 === value)
        .map((item) => ({
          text: String(getValueByLanguage(item.value1, item.value2)),
          value: item.key1,
        })) || []
    setDispatchTypeDetail(_dispatchTypeDetail)
    setIsDisabledDispatchTypeDetail(!value)
  }

  const getData = () => {
    const newPromise = new Promise<AllCountriesResType[]>((res) => res([]))
    const getCountriesAPI: Promise<AllCountriesResType[]> = isGetCountries
      ? scheduleApi.getCountries()
      : newPromise

    const getPurposeTravelAPI: Promise<GeneralMastersResType[]> =
      scheduleApi.getPurposeTravel()
    const getAllDepartments: Promise<DepartmentsResType[]> =
      departmentsApi.getAllDepartments()
    const getDispatchTypeAll: Promise<GeneralMastersResType[]> =
      generalMastersApi.getGeneralMaster(DPTD)

    Promise.all([
      getCountriesAPI,
      getPurposeTravelAPI,
      getAllDepartments,
      getDispatchTypeAll,
    ])
      .then(async (res) => {
        if (res[0]) {
          const _countries: OptionItemType[] = res[0]
            .map((item) => ({
              text: item.countryName,
              value: item.countryCode,
            }))
            .filter((item) => item.value !== UNIVERSAL_COUNTRY_CODE)
          setCountries(_countries)
        }
        const _purposeTravel: OptionItemType[] = res[1].map((item) => ({
          text: String(getValueByLanguage(item.value1, item.value2)),
          value: item.key3,
        }))
        setPurposeTravel(_purposeTravel)
        const _departments: OptionItemType[] = res[2].map((item) => ({
          text: String(
            getValueByLanguage(
              item.departmentNameJapan,
              item.departmentNameEnglish,
            ),
          ),
          value: item.bumonCd,
        }))
        setDepartments(_departments)
        setDispatchTypeAll(res[3])
        const _dispatchType = res[3]
          .filter(
            (item, index, self) =>
              index === self.findIndex((_item) => _item.key2 === item.key2),
          )
          ?.map((item) => ({
            text: String(getValueByLanguage(item.value3, item.value4)),
            value: item.key2,
          }))
        setDispatchType(_dispatchType)
        if (searchCondition?.dispatchType)
          onChangeDispatchType(searchCondition.dispatchType, res[3])
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
      .finally(() => {
        const pathnameList = [SCR210, SCR210_USER_SEARCH]
        if (!pathnameList.includes(pathname) && !state?.searchCondition) {
          setIsLoadingLayout(false)
          setIsLoadingTable(false)
        }
      })
  }

  const getArrivalCities = (arrivalCityCode: string) => {
    countriesApi
      .getCitiesByCountry(arrivalCityCode)
      .then((res: CitiesResType[]) => {
        const optionItem: OptionItemType[] = res.map((item) => ({
          text: item.cityDistrict,
          value: item.cityCode,
        }))
        setArrivalCities(optionItem)
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const state = pushStateError(error)
        push({ pathname: SCR973, state })
      })
  }

  return {
    arrivalCities,
    countries,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    handleSearch,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenLoadData,
    isOpenShowData,
    isPathnameAttentionsOrSafeties,
    isResetTable,
    onCancelCustomLoadData,
    onChange,
    onChangeDispatchType,
    onChangeTable,
    onOkLoadData,
    onOkShowData,
    overRecordLabel,
    perItem,
    purposeTravel,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingTable,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    travelScheduleId,
    userInformation,
  }
}
